import { RefObject, useEffect, useState } from 'react'

export const useVirtuosoScrollParent = (
	containerRef: RefObject<HTMLElement>
) => {
	const [scrollParent, setScrollParent] = useState<HTMLElement | null>(null)

	useEffect(() => {
		const container = containerRef.current
		if (!container) return

		setScrollParent(
			container.closest(
				'[data-virtuoso-scroll-parent="true"], main'
			) as HTMLElement | null
		)
	}, [containerRef])

	return scrollParent
}
